// src/components/ScoreboardAdmin/PenaliteComponent.jsx
import React from "react";

const PenaliteComponent = ({ penalites, setPenalites }) => {
  const label =
    penalites === 3 ? "Hansoku-make" : penalites === 2 ? "Shido ×2" : penalites === 1 ? "Shido ×1" : "Shido";

  const tone =
    penalites === 3
      ? "bg-rose-600 text-white"
      : penalites > 0
      ? "bg-amber-400 text-black"
      : "bg-slate-200 text-slate-900 dark:bg-slate-600 dark:text-white";

  const Button = ({ disabled, onClick, children }) => (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`w-9 h-9 rounded-full text-white text-sm font-bold flex items-center justify-center
        ${disabled ? "bg-slate-400 cursor-not-allowed" : "bg-indigo-600 hover:bg-indigo-500 active:scale-[0.98]"} `}
    >
      {children}
    </button>
  );

  return (
    <div className="flex items-center gap-2">
      <Button disabled={penalites === 0} onClick={() => setPenalites((v) => Math.max(0, v - 1))}>
        –
      </Button>

      <div className={`w-32 sm:w-36 h-10 rounded-xl grid place-items-center text-sm sm:text-base font-semibold ${tone}`}>
        {label}
      </div>

      <Button disabled={penalites === 3} onClick={() => setPenalites((v) => Math.min(3, v + 1))}>
        +
      </Button>
    </div>
  );
};

export default PenaliteComponent;
